export default "__VITE_ASSET__CvbWUiwg__"